'use strict';

(function () {
    const hasBooqableWidgets = document.querySelector(
        '.booqable-product, .booqable-product-detail, .booqable-product-button, .booqable-product-list, .booqable-datepicker, #booqable-cart, .trailers-filter-btn'
    );
    if (!hasBooqableWidgets) {
        // Avoid long-running polling on pages without Booqable widgets.
        return;
    }

    const booqableCompany = 'fcc77abd-69c1-42bd-9ed6-f1fdc1baef0d';

    function loadScriptOnce(id, src, isAsync = true) {
        if (document.getElementById(id) || document.querySelector(`script[src="${src}"]`)) {
            return;
        }

        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = isAsync;
        script.defer = !isAsync;
        document.head.appendChild(script);
    }

    window.booqableOptions = window.booqableOptions || { company: booqableCompany };
    loadScriptOnce('codeq-booqable-main', `https://${booqableCompany}.assets.booqable.com/v2/booqable.js`);
    loadScriptOnce('codeq-booqable-product-properties', '/booqable-product-properties.js', false);

/**
 *
 * Weekend Discounts
 *
 * To have discounts over weekend we use Booqables coupon code feature and
 * automatically apply a coupon based on the start and end dates of the cart.
 *
 * We also differenciate between weekend discounts for trailers and the truck.
 *
 */

    function onDependencyLoaded(attempts = 0) {
        const store = window.booqableStore || window.store;
        if (store) {
            couponCodeWeekendLogic();
            return;
        }

        if (attempts < 100) {
            setTimeout(() => onDependencyLoaded(attempts + 1), 300);
        }
    }
    setTimeout(onDependencyLoaded, 300);

    function couponCodeWeekendLogic() {
        const store = window.booqableStore || window.store;
        let latestStartsAt = false;
        let latestStopsAt = false;
        let currentCouponCode = false;

    /* uses global store */
    function getCart() {
        const state = store.getState();
        const cartId = state.client ? state.client.cartId : false;
        return cartId ? state.orm.carts.getById(cartId) : state.orm.carts.getFirst();
    }

    /* uses global store */
    function onStoreDataChange() {
        const cart = getCart();
        if (!cart) {
            // booqable not initialized yet
            setTimeout(onStoreDataChange, 300);
            return;
        }
        const startsAt = cart.starts_at;
        const stopsAt = cart.stops_at;

        // this fn triggers relatively often, so check for date changes
        if (startsAt === latestStartsAt && stopsAt === latestStopsAt) {
            return;
        }
        latestStartsAt = startsAt;
        latestStopsAt = stopsAt;

        updateCouponCode(startsAt, stopsAt);
    }
    store.subscribe(onStoreDataChange);
    onStoreDataChange();

    function parseUtcDate(dateAsString) {
        const date = new Date(dateAsString);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    function updateCouponCode(startsAt, stopsAt) {
        const start = parseUtcDate(startsAt);
        const end = parseUtcDate(stopsAt);
        if (!start || !end) {
            return;
        }

        const isTrailer = document.querySelector('.trailer-list');
        const isTruck = document.querySelector('[data-id="abschleppwagen"]');
        const startIsValidForLongWeekend = start.getUTCDay() === 4 && start.getUTCHours() >= 17; // Thursday after 17:00
        const startIsValidForShortWeekend = start.getUTCDay() === 5 && start.getUTCHours() >= 13; // Friday after 13:00
        const endsWithMondayBeforeOrAt9 =
            end.getUTCDay() === 1 &&
            (end.getUTCHours() < 9 || (end.getUTCHours() === 9 && end.getUTCMinutes() === 0)); // Monday before/at 9:00

        const diffInMilliseconds = end.getTime() - start.getTime();
        const diffInDays = diffInMilliseconds / 1000 / 60 / 60 / 24;
        const isOneWeekend = diffInDays > 2 && diffInDays < 4;

        let identifier;
        let cssClass;
        if (isTrailer) {
            // this is a trailer
            if (startIsValidForLongWeekend && endsWithMondayBeforeOrAt9 && isOneWeekend) {
                identifier = 'Anhänger Wochenend-Rabatt - Do. 17 Uhr bis Mo. 9 Uhr';
                cssClass = 'has-trailer-weekend-discount-long';
            } else if (startIsValidForShortWeekend && endsWithMondayBeforeOrAt9 && isOneWeekend) {
                identifier = 'Anhänger Wochenend-Rabatt - Fr. 13 Uhr bis Mo. 9 Uhr';
                cssClass = 'has-trailer-weekend-discount-short';
            } else {
                identifier = '';
                cssClass = false;

                if (isOneWeekend && start.getUTCDay() === 4) {
                    cssClass = 'recommend-trailer-weekend-discount-long';
                } else if (isOneWeekend && start.getUTCDay() === 5) {
                    cssClass = 'recommend-trailer-weekend-discount-short';
                }
            }
        }
        if (isTruck) {
            // this is the truck
            if (startIsValidForShortWeekend && endsWithMondayBeforeOrAt9 && isOneWeekend) {
                identifier = 'Autotransporter Wochenend-Rabatt - Fr. 13 Uhr bis Mo. 9 Uhr';
                cssClass = 'has-truck-weekend-discount-short';
            } else {
                identifier = '';
                cssClass = false;

                if (isOneWeekend && start.getUTCDay() === 5) {
                    cssClass = 'recommend-truck-weekend-discount-short';
                }
            }
        }

        // set the coupon code on the body tag, so that we can show notices
        // with CSS (we shouldn't change the React dom directly, since we can't control rendering)
        const bodyClassList = document.querySelector('body').classList;
        bodyClassList.remove('has-trailer-weekend-discount-long');
        bodyClassList.remove('has-trailer-weekend-discount-short');
        bodyClassList.remove('recommend-trailer-weekend-discount-long');
        bodyClassList.remove('recommend-trailer-weekend-discount-short');
        bodyClassList.remove('has-truck-weekend-discount-short');
        bodyClassList.remove('recommend-truck-weekend-discount-short');
        if (cssClass) bodyClassList.add(cssClass);

        setCouponCode(identifier);
    }

    function setCouponCode(identifier) {
        if (identifier === currentCouponCode) {
            return; // nothing to do
        }
        currentCouponCode = identifier;
        const cartId = getCart().id;
        const options = {
            cart_id: cartId,
            identifier: identifier,
        };

        fetch('https://schuetz-wien.booqable.shop/api/1/cart/redeem_coupon', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(options),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to redeem Booqable coupon code');
                }
                return response;
            })
            .then(() => {
                // Will populate the state with new data
                const CartActions = (window.Model.default || window.Model).Cart.actions;
                CartActions.fetch({ id: cartId });
            })
            .catch(() => {
                // Keep previous behavior of failing silently for the user.
            });
    }
    }


/**
 * OTHER SHOP INTEGRATION PART
 */




(function () {
    'use strict';

    /**
     * This code is originally from Johan from Booqable
     * We replace the default booqable "buy now" button with our own "reserve now".
     *
     * The original button is hidden with CSS.
     */
    /* uses global store */
    function getCart() {
        const store = window.booqableStore || window.store;
        const state = store.getState();
        const cartId = state.client ? state.client.cartId : false;
        return cartId ? state.orm.carts.getById(cartId) : state.orm.carts.getFirst();
    }

    function replaceBuyWithReserveButton() {
        let button = document.querySelector('#custom-checkout-button');
        const buttonContainer = document.querySelector('#booqable-sidebar-summary');

        // Append button to the cart if it doesn't exist and the button container is present in the DOM.
        if (!button && buttonContainer) {
            // hide the default checkout button
            document.querySelector('body').classList.add('hide-default-checkout-button');

            button = document.createElement('a');
            button.id = 'custom-checkout-button';
            button.innerHTML = 'Jetzt reservieren';
            button.className = 'bq-branded bq-button bq-enabled';

            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                let url = 'https://shop.schuetz-wien.at/checkouts/' + getCart().id;
                if (window.trailerFilterCurrentConfig) {
                    const config = window.trailerFilterCurrentConfig;
                    url += '?license=' + config.license + '&maxCarWeight=' + config.maxCarWeight + '&maxTrailerWeight=' + config.maxTrailerWeight + '&maximalAllowedWeight=' + config.maximalAllowedWeight;
                }
                window.location = url;
            });

            buttonContainer.appendChild(button);
        }
    }

    let lastCartLinesString = null;
    function callIfProductsHaveChanged(callback) {
        if (getCart()?.lines?.toString() === lastCartLinesString) {
            return;
        }
        lastCartLinesString = getCart()?.lines?.toString();
        callback();
    }

    function updateServicesAvailable() {
        const productNameElements = Array.from(document.querySelectorAll('#booqable-sidebar-lines .bq-product-name'));
        let showTruckInsurance = false;
        let showTrailerSmallInsurance = false;
        let showTrailerLargeInsurance = false;
        productNameElements.forEach(productNameElement => {
            const config = getProductConfiguration(productNameElement.innerText);
            switch (config?.insuranceOffer) {
                case 'Abschleppwagen':
                    showTruckInsurance = true;
                    break;
                case 'Anhänger klein':
                    showTrailerSmallInsurance = true;
                    break;
                case 'Anhänger groß':
                    showTrailerLargeInsurance = true;
                    break;
            }
        });

        document.body.classList[showTruckInsurance ? 'add' : 'remove']('show-truck-insurance-in-cart');
        document.body.classList[showTrailerSmallInsurance ? 'add' : 'remove']('show-trailer-small-insurance-in-cart');
        document.body.classList[showTrailerLargeInsurance ? 'add' : 'remove']('show-trailer-large-insurance-in-cart');
    }

    function getProductConfiguration(productName) {
        return window.booqableProductProperties.find(productConfig => productConfig.name === productName);
    }


    // We have to wait for Booqable to be loaded as we
    // can only observe changes to a DOM element that exists.
    const initBooqableButton = setInterval(() => {
        const booqableCartTarget = document.querySelector('#booqable-cart');

        if (booqableCartTarget && window.booqableProductProperties) {
            // Use a MutationObserver since we can't predict when React mutates the DOM.
            // This makes our live easier making sure our button always has it's click binding.
            const booqableCartObserver = new MutationObserver(() => {
                replaceBuyWithReserveButton();
                callIfProductsHaveChanged(updateServicesAvailable);
            });

            const booqableObserveConfig = {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true,
            };

            booqableCartObserver.observe(booqableCartTarget, booqableObserveConfig);

            clearInterval(initBooqableButton);
        }
    }, 150);
})();
})();
